import {createIssueTypeAction} from '../../../app/actions';
import {isCreatingIssueTypesAdmin, getIssueTypeNames} from '../../../app/selectors';
import {connect} from '../../../app/connect';
import IssueTypesAdminCreateModal from './IssueTypesAdminCreateModal';

const mapStateToProps = state => ({
  isCreating: isCreatingIssueTypesAdmin(state),
  issueTypeNames: getIssueTypeNames(state)
});

const mapDispatchToProps = {
  createIssueTypeAction
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueTypesAdminCreateModal);
